import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  constructor(private http: HttpClient) {}

  verifyToken(token: string, userAction: string = '') {
    const body = {
      event: {
        token: token,
        expectedAction: userAction,
        siteKey: environment.recaptcha.v2SiteKey
      }
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(
      `https://recaptchaenterprise.googleapis.com/v1/projects/${environment.recaptcha.projectId}/assessments?key=${environment.recaptcha.apiKey}`,
      body,
      { headers: headers }
    );
  }
}